import { useEventCallback } from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import { TMDataContext } from "../../utils/custom_hooks/TMDataContext";
import { InterviewGoalTemplate } from "../classes/goal_template_interview_class";
import { FormNavigationController } from "../common/components/FormNavigationController";
import { FormTitle } from "../common/components/generalUtilities";
import { InterviewFormContext } from "../hooks/InterviewFormContext";
import { InterviewGoalShape } from "../interfaces/classTypes";
import { InterviewForm } from "./components/InterviewForm";
import { InterviewPreview } from "./components/InterviewPreview";

export const InterviewContainer: React.FunctionComponent = () => {
  const { DBObject, t, navPage } = useContext(TMDataContext);

  // move the defaults to the router object.  Depending on the router command, load either the goal Defaults or the template from the db.
  let interviewDefaults = navPage.formDefaults
    ? navPage.formDefaults
    : { user: DBObject.User };

  const interviewGoalObject = new InterviewGoalTemplate(interviewDefaults);
  const [CRUDtype] = useState(navPage.formDefaults ? "edit" : "new");
  const [goalState, setGoalState] = useState<InterviewGoalShape>(
    interviewGoalObject
  );

  const [formComplete, setFormComplete] = useState(false);

  const showStep = () => {
    switch (navPage.name) {
      case "interviewForm":
        return <InterviewForm setStepComplete={setFormComplete} />;
        break;
      case "interviewPreview":
        return <InterviewPreview />;
        break;
    }
  };

  return (
    <InterviewFormContext.Provider
      value={{
        goalState,
        setGoalState,
      }}
    >
      <div className="goal-wizard-container">
        <FormTitle
          title={t(
            `views.goals.form_titles.interview_goal_${CRUDtype}${
              navPage.name.includes("Preview") && CRUDtype ? "_preview" : ""
            }`
          )}
        />
        <div className="goal-form-dashboard">{showStep()}</div>
        <FormNavigationController
          stepComplete={formComplete}
          goalState={goalState}
        />
      </div>
    </InterviewFormContext.Provider>
  );
};
